export const MAX_ATTEMPTS = 3;
export const GOOGLE_API_CLIENT_ID = import.meta.env.VITE_APP_GOOGLE_API_CLIENT_ID;
export const APPLE_CLIENT_ID = import.meta.env.VITE_APPLE_CLIENT_ID;
export const BASE_URL = import.meta.env.VITE_APP_API_URL;
export const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT;
export const IS_PROD = ENVIRONMENT === 'prod';
export const IS_DEV = ENVIRONMENT === 'dev';
export const SCORECARD_KEY = import.meta.env.VITE_COLLEGE_SCORECARD_API_KEY;
